import script from "./DateTimeBadge.vue?vue&type=script&setup=true&lang=ts"
export * from "./DateTimeBadge.vue?vue&type=script&setup=true&lang=ts"

import "./DateTimeBadge.vue?vue&type=style&index=0&id=6808839a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6808839a"]])

export default __exports__